import notification from '@/ApiConstance/toast'
import { api } from '../index'

export default {
  async createPayment(payload) {
    return await api.post('/storepayment', payload).then(() => {

    })
  },
  async allPayments(payload) {
    return await api.post('/getallpayments', payload)
  },

  // Fetch the consolidated payment due summary for the admin list page.
  async getPaymentDueList(params = {}) {
    return api.get('/payment-due-list', { params })
  },

  async getInvoice(id) {
    return await api.get(`/invoice/${id}`)
  },

  async getpaymentlogs(payload) {
    return await api.get('/getpaymentlogs', {
      params: payload,
    })
  },

}
